import { CustomNode, NodeType } from '@/types/node-types';

// clear node results and status events, removing artifact nodes
export function clearNodeResults(nodes: CustomNode[]): CustomNode[] {
  return nodes
    .filter((node) => node.type !== NodeType.ArtifactNode)
    .map((node) => ({
      ...node,
      data: {
        ...node.data,
        result: undefined,
        nodeStatusEvents: [],
      },
    }));
}
